// src/utils/agirPour.js
//
// ESPACE CONSULTANT — séparé de l'espace créateur.
//
//  • Consultant : se connecte sur /consultant/login (API login/consultant)
//                 → token stocké dans "token_consultant"
//  • Admin      : clique "Publier pour un créateur" dans l'admin
//                 → on réutilise "token_admin"
//  • Créateur   : rien ne change, il garde "token"
//
// Clé "espace" = "consultant" | "admin" → dit qu'on est dans l'espace /consultant.
// Quand un créateur est choisi, toutes les requêtes API reçoivent
// l'en-tête  X-Agir-Pour: {id du créateur}  (le backend agit en son nom).
//
// À appeler UNE fois au démarrage : installerAgirPour()  (dans src/index.js)

import { base_url } from "./constante";

const CLE_CREATEUR = "agir_pour"; // { id, nom }
const CLE_ESPACE = "espace";      // "consultant" | "admin"

// ══════════════ CRÉATEUR ACTIF ══════════════

export function getCreateurActif() {
    try {
        return JSON.parse(localStorage.getItem(CLE_CREATEUR) || "null");
    } catch {
        return null;
    }
}

export function setCreateurActif(createur) {
    if (createur) localStorage.setItem(CLE_CREATEUR, JSON.stringify({ id: createur.id, nom: createur.nomComplet || createur.nom }));
    else localStorage.removeItem(CLE_CREATEUR);
    window.dispatchEvent(new Event("agir-pour-change"));
}

// ══════════════ ESPACE ══════════════

export function getEspace() {
    return localStorage.getItem(CLE_ESPACE); // "consultant" | "admin" | null
}

export function ouvrirEspace(espace) {
    localStorage.setItem(CLE_ESPACE, espace);
}

export function estConsultant() {
    return getEspace() === "consultant";
}

export function estAdminEspace() {
    return getEspace() === "admin";
}

// Consultant ou admin dans l'espace /consultant : agit au nom d'un créateur.
// ⚠️ Uniquement sur les pages /consultant… → l'espace créateur (/EspaceClient)
//    et l'admin (/admin) ne sont JAMAIS impactés, même dans le même navigateur.
const dansEspaceConsultant = () => window.location.pathname.startsWith("/consultant");

export function peutAgirPour() {
    if (!dansEspaceConsultant()) return false;
    const e = getEspace();
    return (e === "consultant" && !!localStorage.getItem("token_consultant"))
        || (e === "admin" && !!(localStorage.getItem("token_admin") || sessionStorage.getItem("token_admin")));
}

// Token à utiliser dans l'espace consultant
export function getTokenEspace() {
    const e = getEspace();
    if (e === "consultant") return localStorage.getItem("token_consultant");
    if (e === "admin") return localStorage.getItem("token_admin") || sessionStorage.getItem("token_admin");
    return null;
}

// Token pour AddEvent2 / UpdateEvent2 : espace consultant OU créateur normal
export function getTokenPublication() {
    if (peutAgirPour()) return getTokenEspace();
    return localStorage.getItem("token") || sessionStorage.getItem("token");
}

// Quitter l'espace consultant
export function fermerEspace() {
    const e = getEspace();
    if (e === "consultant") {
        localStorage.removeItem("token_consultant");
        localStorage.removeItem("consultant_nom");
    }
    localStorage.removeItem(CLE_ESPACE);
    setCreateurActif(null);
    return e;
}

// ══════════════ INTERCEPTION fetch / axios ══════════════

// Ajoute ?agir_pour=ID à l'URL
const ajouterParam = (url, id) =>
    /[?&]agir_pour=/.test(url) ? url : `${url}${url.includes("?") ? "&" : "?"}agir_pour=${id}`;

const versApi = (url) => typeof url === "string" && url.startsWith(base_url);

let installe = false;

export function installerAgirPour() {
    if (installe) return;
    installe = true;

    // ── fetch ──
    const fetchOriginal = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
        const url = typeof input === "string" ? input : input?.url;
        const c = getCreateurActif();
        if (c && peutAgirPour() && versApi(url)) {
            const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined));
            headers.set("X-Agir-Pour", String(c.id));
            init = { ...init, headers };
            // + dans l'URL (au cas où l'en-tête serait retiré par le serveur)
            if (typeof input === "string") input = ajouterParam(input, c.id);
        }
        return fetchOriginal(input, init);
    };

    // ── XMLHttpRequest (axios) ──
    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this.__urlThrundrz = url;
        const c = getCreateurActif();
        if (c && peutAgirPour() && versApi(url)) url = ajouterParam(url, c.id);
        return open.call(this, method, url, ...rest);
    };
    XMLHttpRequest.prototype.send = function (body) {
        const c = getCreateurActif();
        if (c && peutAgirPour() && versApi(this.__urlThrundrz)) {
            try { this.setRequestHeader("X-Agir-Pour", String(c.id)); } catch { /* déjà envoyé */ }
        }
        return send.call(this, body);
    };
}

// ── Installation AUTOMATIQUE dès que ce fichier est importé ──
// (AddEvent2, UpdateEvent2, ConsultantDashboard l'importent)
// → plus besoin de l'appeler dans index.js
installerAgirPour();